import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AppLayout } from '@/components/layout/AppLayout';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { HomeView } from '@/views/Home';
import { RecentView } from '@/views/Recent';
import { FavoritesView } from '@/views/Favorites';
import { CategoryView } from '@/views/Category';
import { ToolPage } from '@/views/ToolPage';
import { WorkflowsView } from '@/views/Workflows';
import { SettingsView } from '@/views/Settings';
import { NotFoundView } from '@/views/NotFound';

export function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route element={<AppLayout />}>
            <Route path="/" element={<HomeView />} />
            <Route path="/recent" element={<RecentView />} />
            <Route path="/favorites" element={<FavoritesView />} />
            <Route path="/c/:id" element={<CategoryView />} />
            <Route path="/tool/:id" element={<ToolPage />} />
            <Route path="/workflows" element={<WorkflowsView />} />
            <Route path="/settings" element={<SettingsView />} />
            <Route path="*" element={<NotFoundView />} />
          </Route>
        </Routes>
        <Toaster
          theme="system"
          position="bottom-right"
          toastOptions={{
            style: {
              background: 'hsl(var(--bg-elev))',
              color: 'hsl(var(--fg))',
              border: '1px solid hsl(var(--border))',
            },
          }}
        />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
